<template>
  <div id="app">
    <keep-alive>
    <router-view class="router-view" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="router-view" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import allApi from "@/http/allApi.js"
export default {
  mounted(){
    // allApi.getShare().then(res=>{
      // shareCommon(res.data.data.title,res.data.data.desc,res.data.data.img);
    // })
  }
}
</script>

<style lang="less">
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body {
  margin: 0px;
  padding: 0px;
  height: 100%;
  width: 100%;
}
.router-view{
  position: relative;
  height: 100%;
  overflow-y: auto;
}
@view-width:450px;
@media only screen and (min-device-width:768px) and (max-device-width:2048px) and (orientation: portrait){
  .router-view{
    width:@view-width !important;
    left:50%;
    margin-left:calc(-@view-width/2);
  }
  #jqqd{
    width: 350px !important;
  }
}
@media only screen and (orientation:landscape){
  .router-view{
    width:@view-width !important;
    left:50%;
    margin-left: calc(-@view-width/2)
  }
  #jqqd{
    width: 350px !important;
  }
}
</style>
